import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useListingColors } from 'legacyfrontend/hooks/useListingColors';
import {
  listingContainedButtonSx,
  listingOutlinedButtonSx,
} from 'legacyfrontend/hooks/listingMuiButtonSx';
import { FiRefreshCw } from 'react-icons/fi';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    minWidth: '300px',
    maxWidth: '500px',
    width: '90%',
    borderRadius: '12px',
    padding: '16px',
  },
}));

const DialogHeader = styled(DialogTitle)({
  textAlign: 'center',
  fontSize: '1.5rem',
  fontWeight: 600,
  paddingBottom: 0,
});

const ContentWrapper = styled(DialogContent)({
  padding: '24px 16px !important',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const MessageText = styled(Box)({
  textAlign: 'center',
  marginTop: '16px',
  fontSize: '1rem',
});

const ActionButtons = styled(DialogActions)({
  padding: '8px 24px 24px',
  justifyContent: 'center',
});

const ConfirmButton = styled(Button)({
  padding: '10px 24px',
  borderRadius: '8px',
  fontWeight: 600,
});

const IconContainer = styled(Box)({
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '16px',
});

const RefreshIcon = styled(FiRefreshCw)({
  fontSize: '4rem',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  animation: 'spin 2s infinite linear',
});

const RefreshModal = ({
  open,
  onConfirm,
  title = 'Actualizar Resultados',
  message = 'Los precios y disponibilidad de vuelos pueden haber cambiado.',
  detail = 'Vamos a actualizar los resultados para que puedas ver la información más reciente.',
  confirmLabel = 'Actualizar',
  disabled = false,
  secondaryLabel,
  onSecondary,
}) => {
  const { background, text } = useListingColors();

  return (
    <StyledDialog
      aria-describedby='refresh-dialog-description'
      aria-labelledby='refresh-dialog-title'
      disableScrollLock={false}
      onClose={() => {}} // Prevenir cierre
      open={open}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        },
      }}
    >
      <DialogHeader id='refresh-dialog-title'>{title}</DialogHeader>

      <ContentWrapper>
        <IconContainer
          sx={{
            backgroundColor: `${background}20`,
          }}
        >
          <RefreshIcon style={{ color: background }} />
        </IconContainer>

        <MessageText id='refresh-dialog-description'>
          <Typography align='center' variant='body1'>
            {message}
          </Typography>
          <Box mt={2}>
            <Typography align='center' variant='body1'>
              {detail}
            </Typography>
          </Box>
        </MessageText>
      </ContentWrapper>

      <ActionButtons>
        {secondaryLabel && onSecondary ? (
          <Button
            disabled={disabled}
            onClick={onSecondary}
            sx={listingOutlinedButtonSx(background, {
              '&:hover': {
                backgroundColor: `${background}10`,
              },
            })}
            variant='outlined'
          >
            {secondaryLabel}
          </Button>
        ) : null}
        <ConfirmButton
          disabled={disabled}
          onClick={onConfirm}
          sx={listingContainedButtonSx(background, text)}
          variant='contained'
        >
          {confirmLabel}
        </ConfirmButton>
      </ActionButtons>
    </StyledDialog>
  );
};

export default RefreshModal;
